// extracted by mini-css-extract-plugin
export default {"header":"CheckoutHeader_header__vH+rQ","title":"CheckoutHeader_title__N+dpZ","subtitle":"CheckoutHeader_subtitle__god9+"};